import React from "react";
import { ModalConsumer } from "../../contexts/ModalContext";
import Modal from "../molecules/Modal";

const ModalRoot = () => (
  <ModalConsumer>
    {({ component: Component, props, hideModal }) => {
      const {
        title,
        largeGutter,
        mediumGutter,
        noGutter,
        hasShadow,
        border,
        primary,
        height,
        redTitle,
        closeable,
        isCompact,
        ...restProps
      } = props;

      return Component ? (
        <Modal
          largeGutter={largeGutter}
          mediumGutter={mediumGutter}
          noGutter={noGutter}
          hasShadow={hasShadow}
          redTitle={redTitle}
          border={border}
          height={height}
          primary={primary}
          title={title}
          closeable={closeable}
          onRequestClose={hideModal}
          isCompact={isCompact}
        >
          <Component {...restProps} onRequestClose={hideModal} />
        </Modal>
      ) : null;
    }}
  </ModalConsumer>
);

export default ModalRoot;
